import React from "react";

const LocationSection = () => {
  return (
    <section className="bg-white py-16">
      {/* Section Heading */}
      <h2 className="text-4xl md:text-5xl max-w-7xl mx-auto px-6 font-bold noto text-gray-800 mb-8">
        Our Location
      </h2>
      
      <div className="max-w-7xl mx-auto grid md:grid-cols-5 gap-8 px-6">
        {/* Left Section */}
        <div className="bg-gray-100 rounded-xl md:col-span-2 shadow-md p-8 flex flex-col justify-between w-full h-auto ">
          <div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Address</h3>
              <p className="text-gray-600 text-base">
                DSM 439, 4th Floor,
                <br />
                DLF Towers, Shivaji Marg,
                <br />
                Moti Nagar, New Delhi - 110015,
                <br />
                India
              </p>
              <br />
              <p className="text-gray-600 text-base">
              2007, Marina Pear Business Center, <br />
              Trade Center, Sheikh Zayed Road, Dubai,<br />
              United Arab Emirates
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">
                Hours of Operation
              </h3>
              <p className="text-gray-600 text-base">
                Our office lines are open from:
                <br />
                <span className="font-semibold">10am - 6pm</span>
                <br />
                <span className="font-semibold">Mon - Sat</span>
              </p>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="rounded-lg overflow-hidden shadow-md md:col-span-3 min-h-[200px] w-full md:h-full">
          <iframe
            title="Google Map Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14019.365597166885!2d77.1367562!3d28.6537161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03d8d2305d63%3A0xa6c3de80c15776db!2sDLF%20Towers%2C%20Shivaji%20Marg%2C%20Moti%20Nagar%2C%20New%20Delhi%2C%20Delhi%20110015!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
